{
  "list": {
    "title": "Categories",
    "add": "Add Category",
    "columns": {
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "description": "Description",
      "status": "Status"
    },
    "rowActions": {
      "trigger": "Actions for {{name}}"
    }
  },
  "drawer": {
    "createTitle": "Add Category",
    "editTitle": "Edit Category",
    "createDescription": "Categories express how reliable a customer is.",
    "editDescription": "Update this category's information.",
    "fields": {
      "nameAr": "Arabic Name",
      "nameEn": "English Name",
      "description": "Description"
    },
    "created": "Category created successfully",
    "updated": "Category updated successfully"
  },
  "statusConfirmTitle": "Change this category's status?",
  "statusConfirmActivateDescription": "{{name}} will become available in the customer drawer.",
  "statusConfirmDeactivateDescription": "{{name}} will be hidden from the customer drawer, but stays on customers who already have it.",
  "deleteConfirmTitle": "Delete this category?",
  "deleteConfirmDescription": "{{name}} will be permanently removed. This cannot be undone.",
  "deleted": "Category deleted successfully",
  "statusChanged": "Category status changed successfully"
}
